// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Link = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.9 3.121a3 3 0 1 1 4.242 4.243l-3.535 3.535a3 3 0 0 1-4.827-.83l.775-.774a2 2 0 0 0 3.345.898l3.535-3.536a2 2 0 1 0-2.828-2.829L9.813 5.622a4 4 0 0 0-1.286-.128z"
    />
    <path
      fill="currentColor"
      d="M7.364 15.142A3 3 0 1 1 3.121 10.9l3.536-3.535a3 3 0 0 1 4.827.83l-.775.775a2 2 0 0 0-3.345-.898l-3.536 3.536a2 2 0 0 0 2.829 2.828l1.793-1.793c.42.112.855.154 1.287.127z"
    />
  </svg>
);
const ForwardRef = forwardRef(Link);
export default ForwardRef;
